import React, { useEffect, useRef, useState } from 'react';
import ResizableField from '../../../utility/resizableField';
import _ from 'lodash';
import { GridYValue } from '../../../constants';
import { useDebouncedCallback } from 'use-debounce';
import cx from 'classnames';

export const SingleLineElement = function FromElement({
  element,
  handlerChangeOption,
  setPosition,
  innerElemHeight,
  addAutoFillingVariable,
  autoFillingVariables,
}) {
  const inputRef = useRef();
  const inputWrapperRef = useRef();

  const handlerWidthChange = (shift) => {
    var formAreaWidth = document.getElementsByClassName('form-area')[0].offsetWidth;

    setPosition((prevPosition) => {
      return {
        ...prevPosition,
        width: Math.max(
          5,
          Math.min(100 - prevPosition.left, Math.floor((((prevPosition.startWidth / 100) * formAreaWidth + shift) / formAreaWidth) * 100)),
        ),
      };
    });
  };

  const finishWidthChange = () => {
    setPosition((prevPosition) => {
      return {
        ...prevPosition,
        startWidth: prevPosition.width,
      };
    });
  };

  const handlerHeightChange = (shift) => {
    setPosition((prevPosition) => {
      const diff = Math.floor(shift / GridYValue);

      return {
        ...prevPosition,
        height: Math.max(11, prevPosition.startHeight + diff),
        innerElemHeight: Math.max(3, prevPosition.startInnerElemHeight + diff),
      };
    });
  };

  const finishHeightChange = () => {
    setPosition((prevPosition) => {
      return {
        ...prevPosition,
        startHeight: prevPosition.height,
        startInnerElemHeight: prevPosition.innerElemHeight,
      };
    });
  };

  useEffect(() => {
    ResizableField(inputRef.current, handlerWidthChange, finishWidthChange, handlerHeightChange, finishHeightChange);
  }, [inputRef, element, element.options.width]);

  const debouncedUpdateVariables = useDebouncedCallback((value) => {
    const matches = [...value.matchAll(/\{([^}]+)\}/g)].map((m) => m[1]);

    const matchesToCreate = [];
    if (matches.length) {
      for (const match of matches) {
        if (!autoFillingVariables.find((variable) => variable.name.toLowerCase() === match.toLowerCase())) {
          matchesToCreate.push(match);
        }
      }
    }

    addAutoFillingVariable(matchesToCreate);
  }, 2500);

  const handleInputChange = (e) => {
    handlerChangeOption(!!e.target.value, 'filledByCreator', element.id);
    handlerChangeOption(e.target.value, 'valueInput', element.id);
    debouncedUpdateVariables(e.target.value);
  };

  return (
    <div
      className={cx('form-element-flex-label-wrapper', {
        labelPlacementLeft: element.options.labelPlacement === 'left',
      })}
    >
      <label htmlFor={element.id} className="form-label">
        {element.options.label} <span className="required">{element.options.requiredFor ? '*' : ''}</span>
      </label>
      <div className="d-flex input-resizable-wrapper flex-wrap" ref={inputWrapperRef} style={{ height: innerElemHeight }}>
        <input
          name={element.options.name}
          id={element.id}
          ref={inputRef}
          value={element.options.valueInput}
          type="text"
          className={`form-control form-control-${element.options.size}`}
          style={{
            width: '100%',
            height: innerElemHeight,
          }}
          onChange={handleInputChange}
        />
      </div>
      {element.options.instructions && <p className="instructions">{element.options.instructions}</p>}
    </div>
  );
};
